import ApiClient from './ApiClient';

export default class AccountApiClient extends ApiClient {
    
    signIn(authToken) {

        return super.post('Account', 'SignIn', {
            AuthenticationToken: authToken
        });

    }

}


// WEBPACK FOOTER //
// ./src/stores/AccountApiClient.js